import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import Planner from '../planner/Planner'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
const MainAIPlanner = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('AI Planner'),
      component: <Planner />,
      permissionCode: 'AI_PLANNER'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainAIPlanner
